import { render, staticRenderFns } from "./CategoryBanner.vue?vue&type=template&id=64b66b37&scoped=true"
import script from "./CategoryBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CategoryBanner.vue?vue&type=style&index=0&id=64b66b37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b66b37",
  null
  
)

export default component.exports